// extracted by mini-css-extract-plugin
export default {"side-slider":"gaF5yytB2DyKddXN3soGKA==","open":"I8YHGiEEhx3ej6yt-3dl-Q=="};